export const stepsProcess = [
    {
        icon: "https://static.meucupom.com/media/LP%20-%20Devolve/icone1-1.png",
        text: "Lojas pagam para anunciar cupons e promoções no MeuCupom",
    },
    {
        icon: "https://static.meucupom.com/media/LP%20-%20Devolve/Icone_2.png",
        text: "Nós dividimos esse valor com você",
    },
    {
        icon: "https://static.meucupom.com/media/LP%20-%20Devolve/Icone_3.png",
        text: "Você economiza em dobro com os descontos e cashback",
    },
];